/**
 * Route for `lead-ownership-transfer-tracking-sold-to-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LeadOwnershipTransferTrackingSoldToTrackingPage } from "../features/lead-ownership-transfer-tracking-sold-to-tracking/LeadOwnershipTransferTrackingSoldToTrackingPage";

export const leadOwnershipTransferTrackingSoldToTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/lead-ownership-transfer-tracking-sold-to-tracking",
	component: LeadOwnershipTransferTrackingSoldToTrackingPage,
});

export default leadOwnershipTransferTrackingSoldToTrackingRoute;
